// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  
  
  class UpdateCourtBooking extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        court_booking_id: props.match.params.id,
        data_uploaded: false,
        data_error: false,
        mobile_no: '',
        court_name: '',
        start_date: '',
        start_time: '',
        payment_modes: [],
        item_types: [],
        results: {
          court: '',
          start_time: '',
          date: '',
        },
        equipment_details: {
            no_of_racket: 0,
            no_of_shoes: 0,
            no_of_shuttle: 0,
            item_type: 0,
            rental_amount: 0,
            item_amount: 0,
            no_of_hours: 0,
            food_and_beverage:0,
            epigamia_yogurt:0,
            payment_mode: '',
        }, 
        amount:0,
        dialog:false,
      };
      this.handleChange = this.handleChange.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
      this.handleCancelBooking = this.handleCancelBooking.bind(this);

    }
  
    componentDidMount() {
        this.getDetails(this.state.court_booking_id);
        this.getDetailsForRental();
    }

    handleClose = () => {
        this.setState({dialog:false});
        };
  

    getDetailsForRental(data){
      const url = `${getLocationOrigin()}/eagleeye/get_details_for_equipment_rental/`;
      const options = {...defaultOptions};

      return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({payment_modes:data.payment_modes,item_types:data.item_types});
           // alert("fix");
       }).catch(error => error);
    }

    getDetails(data){
        console.log('get details')
        const url = `${getLocationOrigin()}/court_booking/get_details_for_court_booking/?court_booking_id=${data}`;
        const options = {...defaultOptions};

        console.log('Going to fetch')
        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => this.setState({ results: data}))
        .catch(error => error);
    }

    postUpdateBooking(data, details,props) {
        console.log(data);
        if(data.payment_mode == ''){
          alert('Please select payment mode')
        }
        else{
          const url = `${getLocationOrigin()}/eagleeye/update_court_booking/`;
          const options = {...defaultOptions};
          options['method'] = 'post';
          options['headers'] = {'content-type': 'application/json'}
          options['body'] = JSON.stringify({'court_booking_id': data,
                                              'no_of_racket': details.no_of_racket,
                                              'no_of_shoe':details.no_of_shoes,
                                              'no_of_shuttle':details.no_of_shuttle,
                                              'rental_amount':details.rental_amount,
                                              'item_amount':details.item_amount,
                                              'item_type':details.item_type,
                                              'food_and_beverage': details.food_and_beverage,
                                              'epigamia_yogurt': details.epigamia_yogurt,
                                              'payment_mode': details.payment_mode
                                                });
          console.log('Going to fetch');
          return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then(function(response){                     
                alert(response.message);
                props.history.goBack();
            })
            .catch(error => {
              console.log(error);
              alert(error.message);
            });
        }
      }

      postCancelBooking(data, props) {
        console.log(data);
        const url = `${getLocationOrigin()}/court/cancel_court_booking_from_portal/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({'court_booking_id': data,
                                              });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(function(response){                      // first then()
              alert(response.message);
              props.history.goBack();
          })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }

      handleCancelBooking(event){
        event.preventDefault();
        this.postCancelBooking(this.state.court_booking_id, this.props);
      }

    getAmount(data){
        if(data.no_of_racket && data.no_of_hours && data.no_of_shoes && data.no_of_shuttle){
        const url = `${getLocationOrigin()}/eagleeye/get_booking_subscription_amount/?no_of_racket=${data.no_of_racket}&&no_of_hours=${data.no_of_hours}&&no_of_shoe=${data.no_of_shoes}&&no_of_shuttle=${data.no_of_shuttle}`;
        const options = {...defaultOptions};

        console.log('Going to fetch')
        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => this.setState({ amount: data.amount}))
        .catch(error => error);
        }
    }

    handleChange(event) {
        const name = event.target.name;
        var new_value =  Object.assign({}, this.state.equipment_details);
        new_value[name] = event.target.value
        this.setState({equipment_details: new_value});
        // this.getAmount(this.state.equipment_details)
    }

    handleSubmit(event) {
        console.log('handle')
        event.preventDefault();
        console.log('Submit');
        this.postUpdateBooking(this.state.court_booking_id, this.state.equipment_details , this.props)
      }

    render() {
        console.log('amount')
        console.log(this.state.equipment_details);

        // const item_type = {0:'Equipment Rental',1:'Items Sold'}
        const actions = [
            <FlatButton
              label="No"
              primary={true}
              onClick={this.handleClose}
            />,
            <FlatButton
              label="Yes"
              primary={true}
              onClick={this.handleCancelBooking}
            />,
          ]; 
      return(
        <div style={styles.container}>
          <div className="row col-md-9 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12">
              <h3 style={{textAlign:'center'}}>Rental</h3>
            </div>
            <form  className="validated-form form-horizontal">
               
            <div style={styles.items} className="col-md-12">
            <div style={styles.item_header} className="col-md-6">
                Court
              </div>
              <input type="text" name="court_name" className="required" value={this.state.results.court.name} disabled/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Date
              </div>
              <input type="text" style={styles.input} name="date" className="required" value={this.state.results.date} disabled/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Time
              </div>
              <input type="text" style={styles.input} className="required" name="start_time" value={this.state.results.start_time} disabled/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Type
              </div>
              <select name="item_type" className="col-md-6" style={styles.item_body} value={this.state.equipment_details.item_type}
               onChange={this.handleChange}>
                {
                   Object.keys(this.state.item_types).map((key, index) => (
                   <option key={key} value={key}>{`${this.state.item_types[key]}`}</option>
                   ))
                 }
              </select>
            </div>

            { this.state.equipment_details.item_type == 0 ?
              <div className='col-md-12' style={{padding:'0'}}>
                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    No. of Racket
                  </div>
                  <input type="number" style={styles.input} className="required" name="no_of_racket" value={this.state.equipment_details.no_of_racket}
                  onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    No. of Shoe
                  </div>
                  <input type="number" style={styles.input} className="required" name="no_of_shoes" value={this.state.equipment_details.no_of_shoes}
                  onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    No. of Shuttle
                  </div>
                  <input type="number" style={styles.input} className="required" name="no_of_shuttle" value={this.state.equipment_details.no_of_shuttle}
                  onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Equipment Rental Amount
                  </div>
                  <input type="number" style={styles.input} className="required" name="rental_amount" value={this.state.equipment_details.rental_amount}
                  onChange={this.handleChange}/>
                </div>
              </div>
              :
              <div className='col-md-12' style={{padding:'0'}}>
                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Qunatity of F&B
                  </div>
                  <input type="number" style={styles.input} className="required" name="food_and_beverage" value={this.state.equipment_details.food_and_beverage}
                  onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Quantity of Epigamia Yogurt
                  </div>
                  <input type="number" style={styles.input} className="required" name="epigamia_yogurt" value={this.state.equipment_details.epigamia_yogurt}
                  onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Equipment Rental Amount
                  </div>
                  <input type="number" style={styles.input} className="required" name="item_amount" value={this.state.equipment_details.item_amount}
                  onChange={this.handleChange}/>
                </div>
              </div>
            }

            
            <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Payment Modes
                  </div>
                  <select name="payment_mode" className="col-md-6" style={styles.item_body} value={this.state.value}
                   onChange={this.handleChange}>
                     <option>--select--</option>
                    {
                       Object.keys(this.state.payment_modes).map((key, index) => (
                       <option key={key} value={key}>{`${this.state.payment_modes[key]}`}</option>
                       ))
                     }
                  </select>
              </div>
            <div style={{display:'flex', flexDirection:'row', padding:'1%', marginLeft:'10px'}}>
              <div style={styles.button_submit} className="col-md-12">
                <input className="btn btn-lg" type="submit" value="Update Booking" onClick={this.handleSubmit} style={{backgroundColor:'#302C35',
                  color:'#ffffff'}}/>
              </div>
              </div>
              
          </form>
          </div>
        </div>
      );
    }
  }
  
  export default UpdateCourtBooking;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/updateCourtBooking/index.js